import React from 'react';

export const Socials = ({ title, items }: FooterSocials) => {
  const socials = items.map((item, idx) => {
    return (
      <a key={idx} href={item.url} target="_blank">
        <img src={item.imageUrl} alt={item.imageAlt} loading="lazy" className='h-10 w-10'/>
      </a>
    );
  });

  return (
    <div>
      <div className="md:hidden border-t border-solid border-gray-700 -mx-[10px]" />
      <h5 className="uppercase text-white mt-4">{title}</h5>
      <div className="flex flex-row gap-4 mt-3">{socials}</div>
    </div>
  );
};
